import Vue from "vue";
import moment from "moment";
Vue.filter("dateMonth", (value) => {
  if (value) {
    return moment(value).locale("pt-br").format("MM/YYYY");
  }
});
